import React, { useMemo } from 'react';
import { LuTrophy, LuDollarSign } from 'react-icons/lu';
import SafeIcon from '../../common/SafeIcon';

const TopDealsCard = ({ opportunities }) => {
  const topDeals = useMemo(() => {
    return opportunities
      .filter(opp => !['Closed Lost'].includes(opp.stage))
      .sort((a, b) => (parseFloat(b.amount) || 0) - (parseFloat(a.amount) || 0))
      .slice(0, 5);
  }, [opportunities]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const getStageColor = (stage) => {
    const colors = {
      'Lead': 'bg-gray-100 text-gray-700',
      'Qualified': 'bg-blue-100 text-blue-700',
      'Proposal': 'bg-yellow-100 text-yellow-700',
      'Negotiation': 'bg-orange-100 text-orange-700',
      'Closed Won': 'bg-green-100 text-green-700'
    };
    return colors[stage] || 'bg-gray-100 text-gray-700';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          <SafeIcon icon={LuTrophy} className="h-5 w-5 text-yellow-500 mr-2" />
          Top Deals
        </h3>
      </div>
      <div className="space-y-3">
        {topDeals.length === 0 ? (
          <p className="text-sm text-gray-500 text-center py-8">
            No active deals found
          </p>
        ) : (
          topDeals.map((deal, index) => (
            <div
              key={deal.id}
              className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="flex-shrink-0">
                <div className="h-8 w-8 bg-yellow-100 rounded-lg flex items-center justify-center">
                  <span className="text-sm font-bold text-yellow-700">
                    #{index + 1}
                  </span>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {deal.name}
                </p>
                <p className="text-xs text-gray-500 truncate">
                  {deal.accounts?.name || 'Unknown Account'}
                </p>
                <div className="flex items-center space-x-2 mt-1">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${getStageColor(deal.stage)}`}>
                    {deal.stage}
                  </span>
                  <span className="text-xs text-gray-500">
                    {deal.teams?.name}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 text-right">
                <p className="text-sm font-bold text-gray-900">
                  {formatCurrency(deal.amount)}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TopDealsCard;